import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { Address, Salutation } from "../../../models"

@Component({
	selector: 'checkout-address-display-presentation',
	templateUrl: "./checkout-address-display.presentation.html",
	styles: [require("./checkout-address-display.presentation.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutAddressDisplayPresentation {

	@Input() address: Address;

	protected salutation = Salutation
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout-address-display/checkout-address-display.presentation.ts